import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { FilterProps } from "@/types/filters";

export const GroupSizeFilter = ({ value, onChange }: FilterProps) => {
  return (
    <Select value={value || "all"} onValueChange={onChange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Group Size" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Group Size</SelectItem>
        <SelectItem value="small">Small (up to 20)</SelectItem>
        <SelectItem value="medium">Medium (20-50)</SelectItem>
        <SelectItem value="large">Large (50+)</SelectItem>
      </SelectContent>
    </Select>
  );
};